const highChartsLangOptions: Highcharts.Options = {
  lang: {
    numericSymbols: [],
    drillUpText: "◁ Voltar para {series.name}.",
    exitFullscreen: "Sair de tela cheia",
    loading: "Carregando...",
    months: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
    noData: "Sem Dados para exibir para esta janela de tempo.",
    resetZoom: "Restaurar zoom",
    resetZoomTitle: "Redefinir nível de zoom para 1:1",
    shortMonths: [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez",
    ],
    viewFullscreen: "Expandir gráfico em tela cheia",
    weekdays: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
    thousandsSep: ".",
    decimalPoint: ",",
  },
};

export default highChartsLangOptions;
